module.exports = __webpack_public_path__ + "img/settings/Flussonic.d7d7fb.png";